import restApi from "../../http.js";
import session from "@/services/session";

const defaultSize = 33;
export default class DraftApi {
  getDraftCount() {
    return restApi({
      method: "GET",
      url: "/products/draft-count",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  getDraftsByBrandId(brandId, page = 0, size = defaultSize) {
    return restApi({
      method: "GET",
      url: `/products/brands/${brandId}/draft-products?page=${page}&size=${size}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  addDraftProduct(draft, id) {
    return restApi({
      method: "PATCH",
      url: `/products/${id}/activate`,
      data: draft,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  addDraftProducts(drafts) {
    return restApi({
      method: "PATCH",
      url: "/products/add-all-draft",
      data: {
        draft_products: drafts,
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
